import React, { useState, useEffect, useRef } from 'react';
import { FaMicrophone } from 'react-icons/fa'

const Participant = ({ participant, type, comm }) => {
  const [videoTracks, setVideoTracks] = useState([]);
  const [audioTracks, setAudioTracks] = useState([]);
  const videoRef = useRef();
  const audioRef = useRef();

  const trackpubsToTracks = trackMap => Array.from(trackMap.values())
    .map(publication => publication.track)
    .filter(track => track !== null);

  useEffect(() => {
    const trackSubscribed = track => {
      if (track.kind === 'video') {
        setVideoTracks(videoTracks => [...videoTracks, track]);
      } else {
        setAudioTracks(audioTracks => [...audioTracks, track]);
      }
    };
 
    const trackUnsubscribed = track => {
      if (track.kind === 'video') {
        setVideoTracks(videoTracks => videoTracks.filter(v => v !== track));
      } else {
        setAudioTracks(audioTracks => audioTracks.filter(a => a !== track));
      }
    };

    setVideoTracks(trackpubsToTracks(participant.videoTracks));
    setAudioTracks(trackpubsToTracks(participant.audioTracks));

    participant.on('trackSubscribed', trackSubscribed);
    participant.on('trackUnsubscribed', trackUnsubscribed);

    return () => {
      setVideoTracks([]);
      setAudioTracks([]);
      participant.removeAllListeners();
    };
  }, [participant]);

    useEffect(() => {
      const videoTrack = videoTracks[0];
      if (videoTrack) {
        videoTrack.attach(videoRef.current);
        return () => {
          if (typeof videoTrack.stop === "function") {
            // safe to use the function
            videoTrack.stop();
          }
          videoTrack.detach();
        };
      }
    }, [videoTracks]);

    useEffect(() => {
      const audioTrack = audioTracks[0];
      if (audioTrack) {
        audioTrack.attach(audioTrack.current);
        return () => {
          if (typeof audioTrack.stop === "function") {
            // safe to use the function
            audioTrack.stop();
          }
          audioTrack.detach();
        };
      }
    }, [audioTracks]);

  return (
    <div className="participant" style={{maxWidth: '100%'}}>
      <audio ref={audioRef} autoPlay={true} />
      {comm === 'VIDEO'
      && <video ref={videoRef} autoPlay={true} />}
      {comm !== 'VIDEO' &&
        <p style={{textAlign: 'center', color:'white'}}>
          <FaMicrophone style={type === 'remote' ? {fontSize: '3em'} : {fontSize:'2em'}}/>
      </p>}
    </div>
  );
};

export default Participant;
